import "./Confetti.scss";
import {CSSProperties, useMemo} from "react";

// Вибух конфетті з центру батьківського блоку (йому потрібне position: relative).
// Основний колір задається змінною --confetti-accent на батьківському елементі.
const Confetti = ({ count, className = "" }: { count: number, className?: string }) => {
    // параметри частинок генеруємо один раз, щоб вони не перескакували при перерендері
    const pieces = useMemo(() => Array.from({ length: count }, (_, i) => ({
        angle: (360 / count) * i + Math.random() * 12,
        distance: 160 + Math.random() * 220,
        delay: Math.random() * 0.15,
        size: 6 + Math.random() * 7,
        spin: Math.random() * 720 - 360,
        hue: i % 4,
    })), [count]);

    return (
        <div className={`confetti ${className}`} aria-hidden="true">
            { pieces.map((p, i) =>
                <span
                    key={i}
                    className={`confetti-piece hue-${p.hue}`}
                    style={{
                        "--angle": `${p.angle}deg`,
                        "--distance": `${p.distance}px`,
                        "--delay": `${p.delay}s`,
                        "--size": `${p.size}px`,
                        "--spin": `${p.spin}deg`,
                    } as CSSProperties}
                />
            )}
        </div>
    );
};

export default Confetti;
